import { Expose } from 'class-transformer';

export class AssetIntegrationIdData {
    @Expose({ name: 'egl_integrationid' })
    assetIntegrationId: string;

    @Expose({ name: 'egl_assetid' })
    assetid: string;
}
